import { render } from "./updateTodo.vue?vue&type=template&id=da78ba76&scoped=true"
import script from "./updateTodo.vue?vue&type=script&lang=js"
export * from "./updateTodo.vue?vue&type=script&lang=js"

import "./updateTodo.vue?vue&type=style&index=0&id=da78ba76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ad\\Downloads\\internship-project-todolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da78ba76"]])

export default __exports__